// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__DdpiI","image":"styles_image__LWXe1"};